
import React, { useEffect} from "react";
import { FileText } from "lucide-react";
import "./DocumentCards.scss";
import i18n from 'i18next';
import Text from '../../containers/Text';
import { useTranslation } from 'react-i18next';
import InvoiceCard from "./InvoiceCard";
import ReceiptCard from "./ReceiptCard";
import SalaryCard from "./SalaryCard";


const DocumentCards = ({ data = [], docType }) => {
  
    const currentLng = i18n.language;

    const { t } = useTranslation();
    useEffect(() => { console.log("DocumentCards data:", data); })

    if (!data || data.length === 0) {
        return (
            <div className="document-empty-state">
                <FileText className="empty-icon" />
                <Text text={t('no-documents-found')} />
            </div>
        );
    }
    return (
        <div className={`document-cards-container ${currentLng === 'heb' ? 'lang-heb' : ''}`}>
            {data.map((doc) => {
                switch (docType) {
                    case 'invoice':
                        return <InvoiceCard key={doc.id} doc={doc} />;
                    case 'receipt':
                        return <ReceiptCard key={doc.id} doc={doc}/>;
                    case 'salary':
                        return <SalaryCard key={doc.id} doc={doc}/>;
                    default:
                        return null;
                }
            })}
        </div>
    );
};
export default DocumentCards;